import { TrashIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { ConfirmationDialog } from "@components/ConfirmationDialog/ConfirmationDialog";
import { useDeleteComment } from "@components/QaReview/hooks/useDeleteComment";

export const CommentActionDeleteItem: React.FC<{ onOpen: () => void }> = ({ onOpen }) => (
  <DropdownMenuItem
    variant="destructive"
    onClick={(e) => {
      e.stopPropagation();
      onOpen();
    }}
  >
    <TrashIcon />
    Delete
  </DropdownMenuItem>
);

interface CommentActionDeleteDialogProps {
  comment: ReviewItemFieldsFragment;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

// Rendered outside the dropdown: the menu unmounts its items when it closes, which would take the dialog with it.
export const CommentActionDeleteDialog: React.FC<CommentActionDeleteDialogProps> = ({
  comment,
  open,
  onOpenChange,
}) => {
  const { remove, isPending } = useDeleteComment();

  return (
    <ConfirmationDialog
      open={open}
      title="Delete this comment?"
      content="This can't be undone."
      submitButtonText="Delete"
      submitButtonLoading={isPending}
      cancelButtonText="Cancel"
      submitButtonAction="destructive"
      onSubmitClick={() => remove(comment, () => onOpenChange(false))}
      onCancelClick={() => onOpenChange(false)}
    />
  );
};
